import styled from "styled-components";

export const StyledMainContainer = styled.div`
  display: grid;
  grid-auto-rows: 150px max-content;
  grid-row-gap: 41px;
  justify-self: ${p => p.step === 2 && "center"};
`;
export const StyledTextContainer = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-template-columns: auto 1fr;
  grid-column-gap: 18px;
`;
export const StyledTitle = styled.div`
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: grid;
  align-items: center;
  justify-items: center;

  span {
    font-family: "Gilroy", sans-serif;
    font-size: 14px;
    line-height: 8px;
  }

  ${({step}) => step === 1 && `
  border: 0.6px solid;
  border-color: rgba(0, 104, 255, 1);
  background-color: rgba(0, 104, 255, 0.1); 
    span{
      color: rgba(0, 104, 255, 1);
    }
  `}
  ${({step}) => step === 2 && `
  border: 0.6px solid;
  border-color: rgba(137, 195, 92, 1);
  background-color: rgba(137, 195, 92, 0.1); 
    span{
      color: rgba(137, 195, 92, 1);
    }
  `} ${({step}) => step === 3 && `
  border: 0.6px solid;
  border-color: rgba(210, 132, 252, 1);
  background-color: rgba(210, 132, 252, 0.1); 
    span{
      color: rgba(210, 132, 252, 1);
    }
  `}
`;
export const StyledDescription = styled.div`
  font-family: "Gilroy", sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 30px;
  color: #264445;
`;
export const StyledImageContainer = styled.div`
  @media (max-width: 960px) {
    justify-self: center;
    
  }

  img {
    max-height: 150px;
  }
`;